import axios from 'axios'
import store from '../store'
import companyApi from "@/api/company";
import eventApi from "@/api/event";
import posApi from "@/api/pos";
import productApi from "@/api/product";
import timeslotApi from "@/api/timeslot";
import orderApi from "@/api/order";
import customerInformationApi from "@/api/customerInformation";
import discountcodeApi from "@/api/discountcode";
import ticketApi from "@/api/ticket";
import auditApi from "@/api/audit";
import reportApi from "@/api/report";
import cdnApi from "@/api/cdn";
import mailApi from "@/api/mail";
import openingHourApi from "@/api/openingHour";
import customerSupportApi from "@/api/customerSupport"
import DefaultValuesApi from "@/api/defaultValues";
import CampaignApi from "@/api/campaign";
import batchesApi from "@/api/batch";
import settingsApi from "@/api/setting";


if (window.location.host === 'localhost:8083') {
    // Local development environment
    axios.defaults.baseURL = 'http://api.fairtix.local'
} else if (window.location.host === 'frontend.staging.fairtix.io') {
    // Test environment Staging (staging-ft)
    axios.defaults.baseURL = 'https://api.staging.fairtix.io'
} else {
    axios.defaults.baseURL = 'https://api.fairtix.io'
}

axios.interceptors.request.use((config) => {
    let token = store.state.token
    if (token) {
        config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
}, (error) => {
    // Do something with request error
    document.location = '/'
    return Promise.reject(error)
})

axios.interceptors.response.use((response) => {
    return response.data
}, (error) => {
    // Do something with response error
    if (error.response.status === 401) {
        store.commit('logout')
    }
    if (error.response.status === 400) {
        store.commit('errors', error.response.data)
    }
    return Promise.reject(error)
})

const company = () => {
    return new companyApi(axios)
}

const event = () => {
    return new eventApi(axios)
}

const product = () => {
    return new productApi(axios)
}

const pos = () => {
    return new posApi(axios)
}
const timeslot = () => {
    return new timeslotApi(axios)
}

const order = () => {
    return new orderApi(axios)
}

const customerInformation = () => {
    return new customerInformationApi(axios)
}

const discountcode = () => {
    return new discountcodeApi(axios)
}

const ticket = () => {
    return new ticketApi(axios)
}
const audit = () => {
    return new auditApi(axios)
}
const report = () => {
    return new reportApi(axios)
}
const cdn = () => {
    return new cdnApi(axios)
}
const mail = () => {
    return new mailApi(axios)
}

const openingHour = () => {
    return new openingHourApi(axios)
}

const customerSupport = () => {
    return new customerSupportApi(axios)
}

const defaultValues = () => {
    return new DefaultValuesApi(axios)
}

const campaign = () => {
    return new CampaignApi(axios);
}

const batch = () => {
    return new batchesApi(axios)
}

const setting = () => {
  return new settingsApi(axios)
}

export default {
    company,
    event,
    product,
    pos,
    timeslot,
    order,
    customerInformation,
    ticket,
    discountcode,
    audit,
    report,
    cdn,
    mail,
    openingHour,
    customerSupport,
    defaultValues,
    campaign,
    batch,
    setting
}

